<template>
  <div class="SubscriptionConfirmation">
    <transition name="fade" mode="out-in">
      <app-loading
        class="fullscreen"
        v-if="isLoading"
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>
    <template v-if="!isLoading">
      <header-banner
        :img-src-mobile="subscriptionDetails.headerImageUrlOfMobile"
        :img-src-desktop="subscriptionDetails.headerImageUrlOfDesktop"
      />

      <div class="container">
        <div class="SubscriptionConfirmation_top" >
          <router-link to="/my-account" class="BackToAccountView">
            ‹ {{ $t('common.breadcrumbNav.accountOverview', 'Account overview') }}
          </router-link>
          <product
            :name="subscriptionDetails.title"
            :image="subscriptionDetails.imageUrl"
            :success-text="$t('subscription_payinfull.productSuccessText', 'All yours!')"
          />
        </div>
        <div class="SubscriptionConfirmation_body" >
          <h3 class="title">{{ $t('subscription_payinfull.title', 'Congratulations') }} </h3>
          <p class="tips">{{ $t('subscription_payinfull.descriptions', "Thank you for buying, it's all yours now.") }}</p>
          <a
            :href="$t('subscription_payinfull.button.link', '##')"
            class="AppButton"
            @click="trackConversion({ name: 'interaction', description: `register_your_${subscriptionDetails.contentProductName.replace(/\s/i, '_')}` })"
          >
            {{ $t('subscription_payinfull.button', 'Register your') }} {{ subscriptionDetails.contentProductName }}
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import SubscriptionPageMixin from 'mixins/subscription-page'

  export default {
    name: 'subscription-thank-you',

    mixins: [SubscriptionPageMixin]
  }
</script>

<style lang="scss">
  .SubscriptionConfirmation {
    .Product {
      background: $block-bg;
    }

    &_body {
      padding: .3rem 0 1rem;

      @include media(tablet) {
        padding: .5rem .2rem 1rem;
      }

      .title {
        font-size: .24rem;
        line-height: 1.2;
        font-weight: 700;
        margin-bottom: .1rem;
      }

      .tips {
        font-size: .17rem;
        line-height: .25rem;
        margin-bottom: .35rem;

        @include media(tablet) {
          padding-right: 2.25rem;
        }
      }

      .AppButton {
        min-width: 100%;

        @include media(tablet) {
          min-width: 3.55rem;
        }
      }
    }
  }
</style>
